module.exports = __webpack_public_path__ + "img/strawberry02_300px.6166bce0.jpg";